module.exports = __webpack_public_path__ + "static/media/down.5347355e.svg";